"use client";

import { useAuth } from "@/features/auth/context/AuthContext";
import { PageHeader } from "@/components/common/PageHeader";
import { useTranslation } from "react-i18next";
import { Fragment } from "react/jsx-runtime";
import SuperUserApplicationList from "../components/SuperUserApplicationList";
import AdminApplicationList from "../components/AdminApplicationList";

const ApplicationListContent = () => {
  const { profile } = useAuth();

  // Route to the appropriate component based on user role
  if (profile.isSuperUser) {
    return <SuperUserApplicationList />;
  }

  // Default fallback
  return <AdminApplicationList />;
};

export default function ApplicationList() {
  const { t } = useTranslation(["applications"]);
  return (
    <Fragment>
      <PageHeader
        breadcrumbs={[
          { title: t("breadcrumbs.home"), href: "/" },
          { title: t("breadcrumbs.talents") }
        ]}
      />
      <ApplicationListContent />
    </Fragment>
  );
}
